import {
  type SettingsPropsParametricSelector,
  TargetSelector,
  createShallowEqualSelector,
  getColorSelector,
  getSettingValueSelector
} from "@client/selectors";
import { type GenericMap } from "@client/types";
import React from "react";

const ALIGN_MAP: GenericMap<React.CSSProperties> = {
  "left top": { justifySelf: "start", alignSelf: "start" },
  "center top": { justifySelf: "center", alignSelf: "start" },
  "right top": { justifySelf: "end", alignSelf: "start" },
  "left center": { justifySelf: "start", alignSelf: "center" },
  "center center": { justifySelf: "center", alignSelf: "center" },
  "right center": { justifySelf: "end", alignSelf: "center" },
  "left bottom": { justifySelf: "start", alignSelf: "end" },
  "center bottom": { justifySelf: "center", alignSelf: "end" },
  "right bottom": { justifySelf: "end", alignSelf: "end" }
};
export const makeOverlayStyleSelector = (): SettingsPropsParametricSelector => {
  const overlayBackgroundColorSelector = getColorSelector(TargetSelector.Entity, "overlayBackgroundColor");

  return createShallowEqualSelector([overlayBackgroundColorSelector], (overlayBackgroundColor): React.CSSProperties => {
    return {
      backgroundColor: overlayBackgroundColor
    };
  });
};

export const makeStyleSelector = (): SettingsPropsParametricSelector => {
  const positionSelector = getSettingValueSelector(TargetSelector.Entity, "position");

  return createShallowEqualSelector(
    [positionSelector],
    (position): React.CSSProperties => ({
      ...ALIGN_MAP[position]
    })
  );
};
